import { Form, FormInstance, Input } from 'antd';
import * as React from 'react';
import style from '../Protection/Protection.module.scss';
export interface ProtectionLevelThreeProps {
  form: FormInstance;
  levelThree: any;
  handleSubmit: (value: any) => void;
  setIsModalVisible: (value: boolean) => void;
}

export default function ProtectionLevelThree(props: ProtectionLevelThreeProps) {
  const { form, levelThree, handleSubmit, setIsModalVisible } = props;
  React.useEffect(() => {
    form.resetFields();
  }, []);
  return (
    <div className={style.body_container_info}>
      <Form
        form={form}
        initialValues={levelThree}
        layout="vertical"
        hideRequiredMark
        onValuesChange={() => setIsModalVisible(true)}
        onFinish={(values) => handleSubmit(values)}
      >
        <Form.Item
          label={
            <div>
              Level 3 Over_Voltage protection threshold (V){' '}
              <span style={{ color: 'red' }}>[280.00 ~ 300.00]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="o_p_th"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Over_Voltage protection threshold',
              },
              {
                pattern: /^2[8-9][0-9]?\.?[0-9]?[0-9]$|^300?\.?0?0$/,
                message: 'please input parameter value range : [280.00 ~ 300.00]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [280.00 ~ 300.00]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Over_Voltage protection time (s){' '}
              <span style={{ color: 'red' }}>[0.01 ~ 500.00]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="o_p_t"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Over_Voltage protection time (s)',
              },
              {
                pattern:
                  /^0\.[0-9]?[1-9]$|^[1-9]$|^[1-9]?\.[0-9]?[0-9]$|^[1-9][0-9]?\.?[0-9]?[0-9]$|^[1-4][0-9][0-9]?\.?[0-9]?[0-9]$|^500.0?0$/,
                message: 'please input parameter value range : [0.01 ~ 500.00]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [0.01 ~ 500.00]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Low_Voltage protection threshold (V){' '}
              <span style={{ color: 'red' }}>[175.0 ~ 210.0]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="l_p_th"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Low_Voltage protection threshold (V)',
              },
              {
                pattern: /^17[5-9]?\.?[0-9]$|^1[8-9][0-9]?\.?[0-9]$|^20[0-9]?\.?[0-9]$|^210.0$/,
                message: 'please input parameter value range : [175.0 ~ 210.0]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [175.0 ~ 210.0]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Low_voltage protection times (s){' '}
              <span style={{ color: 'red' }}>[0.01 ~ 500.00]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="l_p_t"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Low_Voltage protection times (s)',
              },
              {
                pattern:
                  /^0\.[0-9]?[1-9]$|^[1-9]$|^[1-9]?\.[0-9]?[0-9]$|^[1-9][0-9]?\.?[0-9]?[0-9]$|^[1-4][0-9][0-9]?\.?[0-9]?[0-9]$|^500.0?0$/,
                message: 'please input parameter value range : [0.01 ~ 500.00]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [0.01 ~ 500.00]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Over_Frequency protection threshold (Hz){' '}
              <span style={{ color: 'red' }}>[50.5 ~ 53.0]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="o_f_p_th"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Over_Frequency protection threshold (Hz)',
              },
              {
                pattern: /^50\.[5-9]$|^5[1-2]\.?[0-9]$|^53\.0$/,
                message: 'please input parameter value range : [50.5 ~ 53.0]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [50.5 ~ 53.0]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Over_Frequency protection time (s){' '}
              <span style={{ color: 'red' }}>[0.01 ~ 500.00]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="o_f_p_t"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Over_Frequency protection time (s)',
              },
              {
                pattern:
                  /^0\.[0-9]?[1-9]$|^[1-9]$|^[1-9]?\.[0-9]?[0-9]$|^[1-9][0-9]?\.?[0-9]?[0-9]$|^[1-4][0-9][0-9]?\.?[0-9]?[0-9]$|^500.0?0$/,
                message: 'please input parameter value range : [0.01 ~ 500.00]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [[0.01 ~ 500.00]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Low_Frequency protection threshold (Hz){' '}
              <span style={{ color: 'red' }}>[46 ~ 49]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="l_f_p_th"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Low_Frequency protection threshold (Hz)',
              },
              {
                pattern: /^4[6-9]$/,
                message: 'please input parameter value range : [46 ~ 49]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [46 ~ 49]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label={
            <div>
              Level 3 Low_Frequency protection time (s){' '}
              <span style={{ color: 'red' }}>[0.01 ~ 500.00]</span>
            </div>
          }
          style={{
            margin: 0,
            position: 'relative',
          }}
        >
          <Form.Item
            name="l_f_p_t"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: 'Please enter Low_Frequency protection time (s)',
              },
              {
                pattern:
                  /^0\.[0-9]?[1-9]$|^[1-9]$|^[1-9]?\.[0-9]?[0-9]$|^[1-9][0-9]?\.?[0-9]?[0-9]$|^[1-4][0-9][0-9]?\.?[0-9]?[0-9]$|^500.0?0$/,
                message: 'please input parameter value range : [0.01 ~ 500.00]',
              },
            ]}
          >
            <Input
              placeholder="Input parameter value range : [0.01 ~ 500.00]"
              style={{
                width: '500px',
              }}
            />
          </Form.Item>
        </Form.Item>
      </Form>
    </div>
  );
}
